import React from "react";
import { useSelector } from "react-redux";
import { COLORS } from "../../constants/colors";

const ProgressSidebar = ({ onStepNavigation }) => {
  const { currentStep } = useSelector((state) => state.profileForm);
  const isProfileComplete = useSelector((state) => state.auth.isProfileComplete);

  const steps = [
    { id: 1, title: "Current Situation", description: "Your current career stage" },
    { id: 2, title: "Interest & Reason", description: "Why you're using Ontrack Careers" },
    { id: 3, title: "Personal Information", description: "Basic details about yourself" },
    { id: 4, title: "Education & Professional", description: "Education and work experience" },
    { id: 5, title: "Skills & Competencies", description: "Professional skills and certifications" },
    // { id: 6, title: "AI Skills & Careers", description: "AI-related skills and career interests" },
    { id: 6, title: "Documents Upload", description: "Profile photo and CV" },
  ];

  const handleStepClick = (stepId) => {
    if (isProfileComplete) {
      onStepNavigation(stepId);
    }
  };

  return (
    <div className="w-70 border border-gray-300 shadow-md p-5">
      <div className="mb-6 text-center">
        <h3 className="text-xl font-bold text-gray-800 mb-2">Progress</h3>
        <p className="text-sm text-gray-600">Step {currentStep} of {steps.length}</p>
      </div>
      
      <div className="space-y-3">
        {steps.map((step, index) => (
          <div key={step.id} className="relative">
            <div 
              className={`flex items-center border border-gray-300 gap-4 cursor-pointer p-3 rounded-lg transition-all duration-200 group ${
                step.id === currentStep
                  ? "shadow-sm"
                  : isProfileComplete 
                    ? "hover:bg-gray-50 hover:border hover:border-gray-200 hover:shadow-sm"
                    : ""
              }`}
              style={step.id === currentStep ? { 
                backgroundColor: COLORS.purpleLight, 
                borderColor: COLORS.purple 
              } : {}}
              onClick={() => handleStepClick(step.id)}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-200 ${
                  step.id === currentStep
                    ? "text-white border-2"
                    : step.id < currentStep || isProfileComplete
                    ? "text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
                style={step.id === currentStep ? { 
                  backgroundColor: COLORS.purple, 
                  borderColor: COLORS.purple 
                } : (step.id < currentStep || isProfileComplete) ? { 
                  backgroundColor: COLORS.purple 
                } : {}}
              >
                {step.id < currentStep || isProfileComplete ? "✓" : step.id}
              </div>
              <div
                className={`flex-1 transition-all duration-200 ${
                  step.id === currentStep
                    ? "font-semibold"
                    : step.id < currentStep || isProfileComplete
                    ? "font-medium"
                    : "text-gray-500"
                }`}
                style={step.id === currentStep ? { 
                  color: COLORS.purpleDark 
                } : (step.id < currentStep || isProfileComplete) ? { 
                  color: COLORS.purpleDark 
                } : {}}
              >
                <div className="font-medium text-sm">{step.title}</div>
              </div>
              
              {/* Click indicator for existing users */}
              {isProfileComplete && step.id !== currentStep && (
                <div className="text-xs text-gray-400 hover:text-gray-600 transition-colors duration-200">
                </div>
              )}
            </div>
            
            {/* Vertical line between steps */}
            {index < steps.length - 1 && (
              <div 
                className={`absolute left-7 top-9 w-0.5 h-9 transform -translate-x-1/2 ${
                  step.id < currentStep || isProfileComplete ? "" : "bg-gray-200"
                }`}
                style={step.id < currentStep || isProfileComplete ? { 
                  backgroundColor: COLORS.purple 
                } : {}}
              ></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressSidebar; 